import "./date-countdown";

class SectionPromoBar extends HTMLElement {
  constructor() {
    super();
    this.initFunction();
  }

  initFunction() {
    if (this.querySelectorAll(".swiper-slide").length < 2) return;

    window.loadSwiper.then(({ Swiper, EffectFade }) => {
      const swiperParams = {
        modules: [EffectFade],
        slidesPerView: "auto",
        speed: 1500,
        loop: true,
        allowTouchMove: false,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        a11y: {
          enabled: false,
        },
        navigation: {
          nextEl: this.querySelector("[data-promo-bar-navigation-next]"),
          prevEl: this.querySelector("[data-promo-bar-navigation-previous]"),
        },
        on: {
          slidePrevTransitionEnd: () => {
            const activeSlide = this.swiper.slides[this.swiper.activeIndex];
            if ("swiperAutoplay" in activeSlide.dataset) {
              setTimeout(() => {
                this.swiper.slidePrev(1500);
              }, 50);
            }
          },
          slideNextTransitionEnd: () => {
            const activeSlide = this.swiper.slides[this.swiper.activeIndex];
            if ("swiperAutoplay" in activeSlide.dataset) {
              setTimeout(() => {
                this.swiper.slideNext(1500);
              }, 50);
            }
          },
          slideChangeTransitionStart: () => {
            this.swiper.slides.forEach((slide) => {
              slide.setAttribute("aria-hidden", "true");
              slide.querySelectorAll("a, button").forEach((el) => {
                el.tabIndex = -1;
              });
            });
          },
          slideChangeTransitionEnd: () => {
            const activeSlide = this.swiper.slides[this.swiper.activeIndex];
            activeSlide.removeAttribute("aria-hidden");
            activeSlide.querySelectorAll("a, button").forEach((el) => {
              el.tabIndex = null;
            });
          },
          lock: () => {
            this.classList.add("promo-bar--locked");
          },
          unlock: () => {
            this.classList.remove("promo-bar--locked");
          },
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);

      const activeSlide = this.swiper.slides[this.swiper.activeIndex];

      this.swiper.slides.forEach((slide) => {
        if (slide === activeSlide) return;

        slide.setAttribute("aria-hidden", "true");
        slide.querySelectorAll("a, button").forEach((el) => {
          el.tabIndex = -1;
        });
      });

      this.addEventListener("promo-bar:update", () => {
        this.swiper.update();
      });
    });
  }
}

if (!customElements.get("section-promo-bar")) {
  customElements.define("section-promo-bar", SectionPromoBar);
}
